export * from './TableHeadCol';
